import * as yup from "yup";

export const ApplicationSchema = yup.object().shape({
  Fname: yup.string().required("Required"),
  Lname: yup.string().required("Required"),
  email: yup.string().required("Required"),
  phoneNo: yup
    .string()
    .required("Required")
    .matches(/^\d{10}$/, "Phone number must be exactly 10 digits"),
  jobType: yup.string().required("Required"),
  Etype: yup.string().required("Required"),
  uploadcv: yup.string().required("Required"),
  departments: yup.string(),
  skills: yup.string(),
});
